import { useEffect, useState } from "react";
import axios from "axios";
import { getCookie } from "../../utils/cookieHandler";
import { config } from "../../utils/config";

const contractTypeLabels = {
  pickup_contract: "Pickup Contract",
  pickup_captain_contract: "Pickup Captain Contract",
  customer_rta_contract: "Customer RTA Contract",
  return_contract: "Return Contract",
  return_captain_contract: "Return Captain Contract",
  temporary_contract: "Temporary RTA Contract",
};

const ContractsDisplay = ({ id }) => {
  const [contracts, setContracts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);

    axios
      .get(`${config.apiUrl}/api/vehicles/contracts/${id}`, {
        headers: {
          Authorization: `Bearer ${getCookie("_AT")}`,
        },
      })
      .then((res) => {
        setContracts(res.data);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  if (isLoading)
    return (
      <div className="flex justify-center py-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="animate-spin h-5 w-5"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="#5729BC"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        </svg>
      </div>
    );
  if (error) return <div className="text-red-500">Error: {error}</div>;
  if (!contracts.length) return <div>No contracts found.</div>;

  return (
    <div className="w-full mt-4">
      <table className="w-full border rounded-xl bg-white shadow">
        <thead>
          <tr>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
              Contract ID
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
              Type
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
              Reservation ID
            </th>
          </tr>
        </thead>
        <tbody>
          {contracts.map((contract, idx) => (
            <tr
              key={contract.id}
              className={`cursor-pointer transition hover:bg-primary/10 text-[12px] ${
                idx % 2 === 0 ? "bg-gray-50" : "bg-white"
              }`}
              onClick={() => {
                const a = document.createElement("a");
                const url = `/assets/${contract.name}`;
                a.href = `${config.apiUrl}${url}`;
                a.target = "_blank";
                a.download = "";
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
              }}
            >
              <td className="px-4 py-2 font-mono text-primary text-[12px]">
                {contract.id}
              </td>
              <td className="px-4 py-2 text-[12px]">
                {contractTypeLabels[contract.type] || contract.type}
              </td>
              <td className="px-4 py-2 text-[12px]">
                {contract.reservation_id}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractsDisplay;
